module.exports = __webpack_public_path__ + "static/media/C3.43ee0902.png";


//////////////////
// WEBPACK FOOTER
// ./public/img/C3.png
// module id = 895
// module chunks = 0